import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetPaymentModel } from "@factory/model/query-model-payment";
import { paymentFormDefault } from "./form.default";
import { PaymentFormSchema } from "./form.rule";

export const useFormDefaultPayment = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetPaymentModel | undefined) => {
    return !cachedValue
      ? paymentFormDefault
      : ({
          billing: cachedValue.billing,
          amountPaid: cachedValue.amount_paid,
          avatar: cachedValue.avatar,
          provider: cachedValue.provider,
        } as PaymentFormSchema);
  };

  return {
    getDefault,
  };
};
